import * as Three from 'three';
import React from 'react';

const WIDTH = 85;
const DEPTH = 45;
const HEIGHT = 150;

const objectMaxLOD = makeObjectMaxLOD();
const objectMinLOD = makeObjectMinLOD();

function makeObjectMaxLOD() {
  const window = new Three.Mesh();

  // Define window frame material (gray color)
  const frameMaterial = new Three.MeshLambertMaterial({ color: 0x808080 });

  // Create window frame
  const frameShape = new Three.Shape();
  const frameWidth = 0.5;
  const frameHeight = 0.48;
  const frameThickness = 0.03;

  frameShape.moveTo(-frameWidth / 2, -frameHeight / 2);
  frameShape.lineTo(-frameWidth / 2, frameHeight / 2);
  frameShape.lineTo(frameWidth / 2, frameHeight / 2);
  frameShape.lineTo(frameWidth / 2, -frameHeight / 2);
  frameShape.lineTo(-frameWidth / 2, -frameHeight / 2);

  const frameExtrudeSettings = {
    steps: 2,
    depth: frameThickness,
    bevelEnabled: false,
  };

  const frameGeometry = new Three.ExtrudeGeometry(frameShape, frameExtrudeSettings);
  const frame = new Three.Mesh(frameGeometry, frameMaterial);
  frame.position.z += frameThickness / 2;

  // Create window glass material
  const glassMaterial = new Three.MeshLambertMaterial({ color: 0x0096fd, transparent: true, opacity: 0.5 });
  const glassTexture = new Three.TextureLoader().load('./window.png');
  
  // Define window glass dimensions
  const glassWidth = frameWidth - 0.04;
  const glassHeight = frameHeight - 0.04;
  const glassThickness = 0.01;

  const glassShape = new Three.Shape();
  glassShape.moveTo(-glassWidth / 2, -glassHeight / 2);
  glassShape.lineTo(-glassWidth / 2, glassHeight / 2);
  glassShape.lineTo(glassWidth / 2, glassHeight / 2);
  glassShape.lineTo(glassWidth / 2, -glassHeight / 2);
  glassShape.lineTo(-glassWidth / 2, -glassHeight / 2);

  const glassExtrudeSettings = {
    steps: 2,
    depth: glassThickness,
    bevelEnabled: false,
  };

  const glassGeometry = new Three.ExtrudeGeometry(glassShape, glassExtrudeSettings);
  const glass = new Three.Mesh(glassGeometry, glassMaterial);
  glass.position.z += frameThickness + glassThickness / 2;

  // Add frame and glass to the window object
  window.add(frame);
  window.add(glass);

  return window;
}

function makeObjectMinLOD(){
  let minLobChair = new Three.Mesh();

  let LegGeometry = new Three.CylinderGeometry(0.02, 0.02, 0.5, 8, 8);
  let LegMaterial = new Three.MeshLambertMaterial({ color: 0xd9d7d7 });

  let leg1 = new Three.Mesh(LegGeometry, LegMaterial);
  leg1.rotation.x += Math.PI / 2;
  leg1.position.z += 0.5 / 2;

  let leg2 = new Three.Mesh(LegGeometry, LegMaterial);
  leg2.rotation.x += Math.PI / 2;
  leg2.position.z += 0.5 / 2;
  leg2.position.y += 0.4;

  let leg3 = new Three.Mesh(LegGeometry, LegMaterial);
  leg3.rotation.x += Math.PI / 2;
  leg3.position.z += 0.5 / 2;
  leg3.position.x += 0.4;

  let leg4 = new Three.Mesh(LegGeometry, LegMaterial);
  leg4.rotation.x += Math.PI / 2;
  leg4.position.z += 0.5 / 2;
  leg4.position.y += 0.4;
  leg4.position.x += 0.4;

  minLobChair.add(leg1);
  minLobChair.add(leg2);
  minLobChair.add(leg3);
  minLobChair.add(leg4);

  return minLobChair;
}

export default {
  name: "sedia",
  prototype: "items",

  info: {
    tag: ['furnishings', 'wood'],
    title: "chair",
    description: "chair",
    image: require('./chair.png')
  },

  properties: {
    altitude: {
      label: "altitude",
      type: "length-measure",
      defaultValue: {
        length: 0,
        unit: 'cm'
      }
    }
  },

  render2D: function (element, layer, scene) {

    let angle = element.rotation + 90;

    let textRotation = 0;
    if (Math.sin(angle * Math.PI / 180) < 0) {
      textRotation = 180;
    }

    return (
      <g transform={ `translate(${-WIDTH / 2},${-DEPTH / 2})`}>
        <rect key="1" x="0" y="0" width={WIDTH} height={DEPTH}
          style={{stroke: element.selected ? '#0096fd' : '#000', strokeWidth: "2px", fill: "#84e1ce"}}/>
        <text key="2" x="0" y="0"
          transform={ `translate(${WIDTH / 2}, ${DEPTH / 2}) scale(1,-1) rotate(${textRotation})`}
          style={ {textAnchor: "middle", fontSize: "11px"}}>
        {element.type}
        </text>
      </g>
    )
  },


  render3D: function (element, layer, scene) {

    let newAltitude = element.properties.get('altitude').get('length');

    /************** lod max *********************/

    let chair1 = new Three.Object3D();
    chair1.add(objectMaxLOD.clone());

    let aa = new Three.Box3().setFromObject(chair1);

    let deltaX = Math.abs(aa.max.x - aa.min.x);
    let deltaY = Math.abs(aa.max.y - aa.min.y);
    let deltaZ = Math.abs(aa.max.z - aa.min.z);

    chair1.rotation.x+= -Math.PI/2;
    chair1.position.y+= newAltitude;
    chair1.position.x+= -WIDTH/3.5;
    chair1.position.z+= DEPTH/4;
    chair1.scale.set( 1.5*WIDTH / deltaZ,DEPTH/1.5 / deltaX, HEIGHT / deltaY);

    /************** lod min *********************/

    let chair0 = new Three.Object3D();
    chair0.add(objectMinLOD.clone());
    chair0.rotation.x+= -Math.PI/2;
    chair0.position.y+= newAltitude;
    chair0.position.x+= -WIDTH/3.5;
    chair0.position.z+= DEPTH/4;
    chair0.scale.set( 1.5*WIDTH / deltaZ,DEPTH/1.5 / deltaX, HEIGHT / deltaY);


    /**** all level of detail ***/

    let lod = new Three.LOD();

    lod.addLevel(chair1, 200);
   // lod.addLevel(chair0, 900);
    lod.updateMatrix();
    lod.matrixAutoUpdate = false;

    if (element.selected) {
      let bbox = new Three.BoxHelper(lod, 0x99c3fb);
      bbox.material.linewidth = 5;
      bbox.renderOrder = 1000;
      bbox.material.depthTest = false;
      lod.add(bbox);
    }

    return Promise.resolve(lod);
    }

};
